import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IProposalInfo, IProposalState } from 'shared/types/proposal';

const initialState: IProposalState = {
  proposalInfo: {
    bankInfo: {
      id: undefined,
      name: undefined,
      logo: undefined,
      icon: undefined,
    },
    mortgageRateDiscount: 0,
    discountRateDuration: 0,
  },
};

/* istanbul ignore next */
const proposalSlice = createSlice({
  initialState,
  name: 'proposal',
  reducers: {
    setProposalInfo: (state, action: PayloadAction<IProposalInfo>) => {
      state.proposalInfo = action.payload;
    },
  },
});

export const {
  reducer: proposalReducer,
  actions: { setProposalInfo },
} = proposalSlice;
